import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";

import { Next } from "../../svg/svgImageList";
import Tooltip, { ComponentWithTooltipProps } from "../../tooltip/Tooltip";
import Button from "../../button/Button";
import { videoPlayerService } from "../../../services/video-player/VideoPlayerService";

const elementId = "video-jump-next-timestamp";

export default observer(function JumpToNextTimestamp({
  tooltipTextKey,
}: ComponentWithTooltipProps) {
  const { videoDuration, currentTimestamp, timestamps, jumpNext } = videoPlayerService;

  const isJumpNextDisabled = useMemo(
    () => videoDuration === 0
      || timestamps?.isEmpty()
      || timestamps?.outOfRange(currentTimestamp)
      || timestamps?.isLastTimeStamp(currentTimestamp)
    , [currentTimestamp, videoDuration, timestamps]
  );

  if (isJumpNextDisabled) return <div className="video-control-item" />;

  return (
    <Tooltip id={elementId} title={tooltipTextKey}>
      <Button
        id={elementId}
        onClick={jumpNext}
        disabled={isJumpNextDisabled}
        icon={{
          svg: Next,
          className: "video-control-item jump",
        }}
      />
    </Tooltip>
  );
});
